import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';

import { CustomizedFormErrorMessage } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm';
import classes from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.module.scss';

export const NumberOfSimulations = () => {
    const {
        setValue,
        control,
        formState: { errors },
    } = useFormContext<FormProps>();
    return (
        <>
            <div className={classes.inputTitle}>Number of simulations</div>
            <div className={classes.inputWrapper}>
                <Controller
                    render={({ field }) => (
                        <TextSearchInput
                            {...field}
                            placeholder={'Enter number of simulations'}
                            isSearch={false}
                            handleClear={() => {
                                setValue('numOfSimulations', 0, { shouldValidate: true, shouldDirty: true });
                            }}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                setValue('numOfSimulations', isNaN(value) ? 0 : value, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                });
                            }}
                        />
                    )}
                    name={`numOfSimulations`}
                    control={control}
                    rules={{
                        required: 'Number of simulations is required',
                        min: {
                            value: 1,
                            message: 'Number must be at least 1',
                        },
                        max: {
                            value: 10000,
                            message: 'Number must not exceed 10000',
                        },
                        validate: (value) => value >= 0 || 'Negative numbers are not allowed',
                    }}
                />
            </div>
            {errors.numOfSimulations && <CustomizedFormErrorMessage text={errors.numOfSimulations.message} />}
        </>
    );
};
